import { AnalyticsService } from '~/lib/services/analytics-service'
import { defineServiceComposable } from '~/composables/service-container'

export const useAnalyticsService = defineServiceComposable(
  'analytics',
  () =>
    new AnalyticsService({
      clientCookieService: useClientCookieService(),
    }),
)
